import React, { useState, useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { useTimesheetProvider } from "../../../../Providers/Client/Timesheet";
import moment from "moment";
import CustomTable from "../../../../Components/Table";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const headCells = [
  { disablePadding: false, label: "Week" },
  { disablePadding: false, label: "Hours" },
  { disablePadding: false, label: "Status" },
  { disablePadding: false, label: "" },
];

export default function TimesheetInitial({ jobId, setShowTimesheetDetails, timesheets, setTimesheets }) {

  const { fetchTimesheetsForJob, fetchTimesheets, setSelectedTimesheet } =
    useTimesheetProvider();

  const { id } = useParams()

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    fetchTimesheets();
    fetchTimesheetsForJob(id ?? jobId).then((data) => setTimesheets(data));
  }, []);

  const CustomRow = ({ row }) => {
    return (
      <TableRow hover>
        <TableCell>
          {moment.utc(row.start).format("Do MMM")} -{" "}
          {moment.utc(row.end).format("Do MMM")}
        </TableCell>
        <TableCell>
          {row.hours.toString().padStart(2, "0")}:
          {row.minutes.toString().padStart(2, "0")}
        </TableCell>
        <TableCell>
          {row.status[0] + row.status.slice(1).toLowerCase()}
        </TableCell>
        <TableCell>
          <button
            className="bg-blue-400 text-white px-2 py-1 rounded-md"
            onClick={() => {
              // setShowTimesheetDetails(true);
              // setSelectedTimesheet(row.id);
              navigate(`timesheet/${row.id}`, { state: { from: location } })
            }}
          >
            View Details
          </button>
        </TableCell>
      </TableRow>
    );
  };

  return (
    <CustomTable
      title="Timesheets"
      headCells={headCells}
      rows={timesheets}
      CustomRow={CustomRow}
    />
  );
}
